// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formulate-input-errors{color:red}.v-application .evacuation-advisory-detail-area-table .v-data-table.cdsTable.listView table tbody tr td div.AreaNameKana__c,.v-application .evacuation-advisory-detail-area-table .v-data-table.cdsTable.listView table tbody tr td div.AreaName__c{white-space:normal}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
